"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reeferErrorCodeToTranslation = exports.reeferErrorCodeToIcon = exports.makeErrorCodesTranslations = exports.makeErrorCodeTranslation = exports.ReeferErrorCodeIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reeferErrorCodeIcon = _interopRequireDefault(require("./reefer-error-code-icon"));

var _reeferErrorCodeTranslation = _interopRequireDefault(require("./reefer-error-code-translation"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable no-console */
var reeferErrorCodeToTranslation = function reeferErrorCodeToTranslation(manufacturer, severity) {
  if (!manufacturer || !severity || typeof manufacturer !== 'string') return null;
  var translation;

  try {
    translation = _reeferErrorCodeTranslation["default"][manufacturer.toUpperCase()][String(severity)];

    if (translation === undefined) {
      throw new TypeError("Reefer error code mapping - Missing translation for, ".concat(manufacturer, ", ").concat(severity));
    }
  } catch (e) {
    console.error(e.message);
    translation = null;
  }

  return translation;
};

exports.reeferErrorCodeToTranslation = reeferErrorCodeToTranslation;

var reeferErrorCodeToIcon = function reeferErrorCodeToIcon(manufacturer, severity) {
  if (!manufacturer || !severity || typeof manufacturer !== 'string' || typeof severity !== 'string') return null;
  var icon;

  try {
    icon = _reeferErrorCodeIcon["default"][manufacturer.toUpperCase()][severity.toUpperCase()];

    if (icon === undefined) {
      throw new TypeError("Reefer error code mapping - Missing icon for, ".concat(manufacturer, ", ").concat(severity));
    }
  } catch (e) {
    console.error(e.message);
    icon = null;
  }

  return icon;
};

exports.reeferErrorCodeToIcon = reeferErrorCodeToIcon;

var makeErrorCodeTranslation = function makeErrorCodeTranslation(intl) {
  return function (manufacturer) {
    return function (errorCode) {
      var translationKey = reeferErrorCodeToTranslation(manufacturer, errorCode);

      if (!translationKey) {
        return null;
      }

      return intl.formatMessage({
        id: 'errorcode.reefer'
      }, {
        errorCode: errorCode,
        details: intl.formatMessage({
          id: translationKey
        })
      });
    };
  };
};

exports.makeErrorCodeTranslation = makeErrorCodeTranslation;

var makeErrorCodesTranslations = function makeErrorCodesTranslations(intl) {
  return function (manufacturer) {
    return function (errorCodes) {
      if (!Array.isArray(errorCodes)) {
        return [];
      }

      return errorCodes.map(function (errorCode) {
        var translationKey = reeferErrorCodeToTranslation(manufacturer, errorCode);

        if (!translationKey) {
          return null;
        }

        return intl.formatMessage({
          id: 'errorcode.reefer'
        }, {
          errorCode: errorCode,
          details: intl.formatMessage({
            id: translationKey
          })
        });
      }).filter(function (hasTranslation) {
        return !!hasTranslation;
      });
    };
  };
};

exports.makeErrorCodesTranslations = makeErrorCodesTranslations;

var ReeferErrorCodeIcon = function ReeferErrorCodeIcon(_ref) {
  var manufacturer = _ref.manufacturer,
      severity = _ref.severity;
  var icon = reeferErrorCodeToIcon(manufacturer, severity);

  if (!icon) {
    return null;
  }

  return /*#__PURE__*/_react["default"].createElement(icon);
};

exports.ReeferErrorCodeIcon = ReeferErrorCodeIcon;
ReeferErrorCodeIcon.propTypes = {
  manufacturer: _propTypes["default"].string.isRequired,
  severity: _propTypes["default"].string.isRequired
};